<script>
	import { slide } from "svelte/transition";

	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();
	export let loader;
	$: loader, dispatch("loader", loader);
</script>

<div class="loader" transition:slide>
	<img src="/img/gif/vg-icon.gif" alt="LOADING" />
	<slot />

	<!-- THE CURRENT OPACITY IS DEV-ONLY -->
	<!-- <button on:click={() => (loader = false)}>k</button> -->
</div>

<style>
	img {
		height: 100px;
		max-height: 30vw;
		place-self: center;
	}
	div.loader {
		height: 100dvh;
		width: 100vw;
		position: fixed;
		display: grid;
		place-content: center;
		color: white;
		background-color: rgb(9, 57, 134);
		/* opacity: 0.5; */
		z-index: 30;
		/* background-color: rgba(0, 0, 0, 0.3); */
	}
</style>
